import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabLandingPage } from './tab-landing.page';

const routes: Routes = [
  {
    path: '',
    component: TabLandingPage,
    outlet: 'main-lobby'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TabLandingPageRoutingModule {}
